import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addUserPlan,
  deleteUserPlan,
  getUserPlan,
  getUserPlanDetail,
  updateUserPlan,
} from "store/services/dataManagement/UserPlan";
import { closeAdminModal } from "store/slices/common/adminModal.slice";

export const GetAllUserPlan = createAsyncThunk(
  "plan/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserPlan(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const AddUserPlan = createAsyncThunk(
  "plan/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await addUserPlan(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) {
          onSuccess();
        }
        dispatch(closeAdminModal());
        const response = await getUserPlan(rest);
        if (response.status === 1) {
          return fulfillWithValue(response);
        }
      }
      if (onError) {
        onError();
      }
      return rejectWithValue(res);
    } catch (error) {
      if (onError) {
        onError();
      }
      return rejectWithValue(error);
    }
  },
);
export const DeleteUserPlan = createAsyncThunk(
  "plan/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, onError, ...rest } = payload;
      const res = await deleteUserPlan(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) onSuccess();
        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      if (onError) onError();
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const UpdateUserPlan = createAsyncThunk(
  "plan/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await updateUserPlan(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) {
          onSuccess();
        }
        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      if (onError) {
        onError();
      }
      return rejectWithValue(res);
    } catch (error) {
      if (onError) {
        onError();
      }
      return rejectWithValue(error);
    }
  },
);

export const GetUserPlanDetail = createAsyncThunk(
  "plan/getDetail",
  async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserPlanDetail(id);

      if (res.status === 1) {
        return fulfillWithValue(res);
      }

      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
